module.exports = __webpack_public_path__ + "static/media/shop-service.bdd2abfe.svg";